<template>
	<div class="mediaMusic">
		<iframe 
			width="100%" 
			height="450" 
			scrolling="no" 
			frameborder="no" 
			allow="autoplay" 
			src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/664967298&color=%2394625e&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true">
		</iframe>

		<div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;">
			<a href="https://soundcloud.com/user-807035398" 
				title="We Three Queens" 
				target="_blank" 
				style="color: #cccccc; text-decoration: none;">
				We Three Queens
			</a>

			<a href="https://soundcloud.com/user-807035398/sets/our-christmas-album" 
				title="Our Christmas Album" 
				target="_blank" 
				style="color: #cccccc; text-decoration: none;">
				Our Christmas Album
			</a>
		</div>
	</div>
</template>

<script>
export default{
	name: "Music"
}
</script>

<style scoped lang="scss">
	.mediaMusic{
		width: 100%;
		height: 100%;
	}
</style>